import React, { useContext } from 'react'
import { sortPlayers } from '../../../../../Utils'
import { PlayerItem } from '../PlayerItem'
import { MatchupContext } from '../../../../../Context'
import { CompareCon } from '../../styles'
import { PlayerSortKeys } from '../../../../../Constant/player'

const statList: PlayerSortKeys[] = [
  'gamesPlayed',
  'faceoffs',
  'faceoffPct',
  'groundBalls',
]

export const Faceoff: React.FC<React.PropsWithChildren<unknown>> = () => {
  const {
    teams: [awayTeam, homeTeam],
    awayPlayers,
    homePlayers,
  } = useContext(MatchupContext)!
  const sortFO = (status: string) => {
    const players = status === 'away' ? awayPlayers : homePlayers
    const FOs = sortPlayers(
      players.filter((p) => p.position === 'FO'),
      'faceoffs',
      -1
    )
    return FOs
  }
  const awayFO = sortFO('away')
  const homeFO = sortFO('home')

  return (
    <CompareCon>
      <h2 className="heading">Faceoff comparison</h2>
      <div className="playersContainer">
        <div className="team">
          {awayFO.length >= 2 && (
            <>
              <PlayerItem player={awayFO[0]} statList={statList} team={awayTeam?.data} />
              {awayFO[1].stats?.faceoffs > 3 && (
                <PlayerItem
                  player={awayFO[1]}
                  statList={statList}
                  team={awayTeam?.data}
                />
              )}
            </>
          )}
          {awayFO.length === 1 && (
            <PlayerItem player={awayFO[0]} statList={statList} team={awayTeam?.data} />
          )}
        </div>
        <span className="team"></span>
        <div className="team">
          {homeFO.length >= 2 && (
            <>
              <PlayerItem player={homeFO[0]} statList={statList} team={homeTeam?.data} />
              {homeFO[1].stats?.faceoffs > 3 && (
                <PlayerItem
                  player={homeFO[1]}
                  statList={statList}
                  team={homeTeam?.data}
                />
              )}
            </>
          )}
          {homeFO.length === 1 && (
            <PlayerItem player={homeFO[0]} statList={statList} team={homeTeam?.data} />
          )}
        </div>
      </div>
    </CompareCon>
  )
}
